import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "form", "exitField" ]

  connect() {
    console.log('submit form controller connected on', this.formTarget)
  }

  submit(event) {
    console.log('submit form')
    event.preventDefault()
    this.exitFieldTarget.value = true
    this.formTarget.submit()
  }
}
